module.exports = __webpack_public_path__ + "static/img/provider_icon.009c7680.png";